<app-user-menu/>

<div class="app-row-fill hh-fill gapped tight">
  <div class="sidebar gapped tight pane pane-right">
    @for ($tab of tabs; track $tab.path) {
      @if ($tab.path === '') {
        <div class="app-fill"></div>
      } @else {
        @if (!$tab.condition || $tab.condition()) {
          <a [routerLink]="tabPath($tab)" routerLinkActive="active"
             class="sidebar-link app-row-auto centered-items padded gapped tight-x clickable">
            <icon [type]="$tab.icon"/>
            <div class="name">{{ $tab.label }}</div>
          </a>
        }
      }
    }
  </div>

  <router-outlet/>
</div>
